import { useNavigate } from 'react-router-dom'

export const COUNTRY_URL = '/select-country'

export const useGoToCountryPage = () => {
  const navigate = useNavigate()

  return {
    go: () => {
      navigate(COUNTRY_URL)
    }
  }
}
